import type { RouteObject } from 'react-router';
import { PageCourrier } from './PageCourrier';
import { PageCourriers } from './PageCourriers';
import { PageDocuments } from './PageDocuments';
import { PageDossier } from './PageDossier';
import { PageDossiers } from './PageDossiers';
import { PageNouveauCourrier } from './PageNouveauCourrier';
import { PageNouveauDossier } from './PageNouveauDossier';
import { PageRecherche } from './PageRecherche';
import { PageDecisions } from '../decisions/PageDecisions';

export const routesMetier: RouteObject[] = [
  { path: '/decisions', element: <PageDecisions /> },
  { path: '/courriers', element: <PageCourriers /> },
  { path: '/courriers/nouveau', element: <PageNouveauCourrier /> },
  { path: '/courriers/:id', element: <PageCourrier /> },
  { path: '/dossiers', element: <PageDossiers /> },
  { path: '/dossiers/nouveau', element: <PageNouveauDossier /> },
  { path: '/dossiers/:id', element: <PageDossier /> },
  { path: '/documents', element: <PageDocuments /> },
  { path: '/recherche', element: <PageRecherche /> },
];
